/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Tab_GeographyInputs */

const vi_report_tab_geography = /** @type {(inputs: Report_Tab_GeographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa lý`)
};

/**

* @param {Report_Tab_GeographyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_tab_geography = /** @type {((inputs?: Report_Tab_GeographyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Tab_GeographyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_tab_geography(inputs)
});